import { render, staticRenderFns } from "./writer.vue?vue&type=template&id=4e05e5e9&"
import script from "./writer.vue?vue&type=script&lang=js&"
export * from "./writer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports